"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DoneIcon;

var _react = _interopRequireDefault(require("react"));

function DoneIcon() {
  return _react["default"].createElement("svg", {
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, _react["default"].createElement("g", {
    transform: "translate(-468.000000, -1192.000000)",
    fillRule: "nonzero"
  }, _react["default"].createElement("g", {
    transform: "translate(285.000000, 1071.000000)"
  }, _react["default"].createElement("g", {
    transform: "translate(183.000000, 121.000000)"
  }, _react["default"].createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    cx: "9.98052632",
    cy: "9.98052632",
    r: "9.98052632"
  }), _react["default"].createElement("path", {
    d: "M19.9610088,9.98052632 C19.9610088,15.4698246 15.4697807,19.9610526 9.98048246,19.9610526 C6.79921053,19.9610526 3.99219298,18.5263596 2.18320175,16.2183772 C3.86741228,17.5907018 6.05065789,18.4016228 8.42100877,18.4016228 C13.910307,18.4016228 18.4015351,13.9103947 18.4015351,8.42109649 C18.4015351,6.05074561 17.590614,3.8675 16.2182895,2.18328947 C18.5263158,3.99219298 19.9610088,6.79921053 19.9610088,9.98052632 Z",
    fill: "currentColor"
  }), _react["default"].createElement("path", {
    d: "M16.0656306,6.73354908 C15.8306205,6.12755311 15.3517473,6.22320703 14.8328338,6.32602393 C14.5229344,6.39061146 13.1445843,6.79407222 10.963699,9.09371005 C10.0586688,10.0481165 9.46164668,10.8090018 9.06856821,11.3892835 C8.82844749,11.0944746 8.55335694,10.7790622 8.26446358,10.4900481 C7.37601288,9.60183882 6.38522817,8.99185894 6.34357827,8.96622514 C5.92780362,8.71206015 5.38502696,8.84284486 5.13013763,9.25829757 C4.87557022,9.67375029 5.00595252,10.2174123 5.4210833,10.472543 C5.42957425,10.4778952 6.2803992,11.0039314 7.01540926,11.7391426 C7.76498672,12.4888006 8.44414165,13.5026034 8.45082173,13.5124223 C8.61617384,13.761034 8.8937996,13.9061044 9.18587203,13.9061044 C9.23601288,13.9061044 9.28663662,13.9018791 9.33701892,13.8931467 C9.68172716,13.8332674 9.95862857,13.5755209 10.0430551,13.2359233 C10.0451879,13.2277543 10.3954093,12.2598267 12.2454696,10.3092835 C13.7355702,8.73773419 14.7292926,8.23825733 15.0735984,8.09970602 C15.0768982,8.09914264 15.0792724,8.0989012 15.0837392,8.09797564 C15.0820893,8.09837806 15.0948861,8.09246256 15.1156507,8.08312655 C15.1747654,8.06095351 15.2064354,8.05246256 15.2082463,8.05201991 C15.1912644,8.05624526 15.1824515,8.05729154 15.1824515,8.05729154 L15.1818881,8.05423319 C15.341204,7.98473621 15.6394736,7.85640623 15.6459928,7.85366981 C16.0950873,7.66916276 16.2411235,7.18610441 16.0656306,6.73354908 Z",
    fill: "#FFFFFF"
  })))));
}